module.exports = __webpack_public_path__ + "media/images/logo__rippergc-08d3f098d7d79eaefe8794e5df311a87.png";